// extracted by mini-css-extract-plugin
export default {"switcher":"ThemeSwitcher_switcher__FbSdk","icon":"ThemeSwitcher_icon__ubDag"};